export default __webpack_public_path__ + "static/media/kurtk2.b544bfcc.jpg";